module.exports = __webpack_public_path__ + "static/media/estimationWhat.d870c375.png";